<template>

    <div v-if="track" class="py-3">

        <div class="row text-left">

            <div class="col-md-8 mx-auto">

                <div class="row">

                    <div class="col-md-3">

                        <label for="add-project-track-track-name">
                            Adding Track:
                        </label>

                    </div>

                    <div class="col-md-9">

                        <div class="form-group">

                            <input type="text" class="form-control" id="add-project-track-track-name" v-model="track.title" disabled="disabled">

                        </div>

                    </div>

                </div>

                <div class="row">

                    <div class="col-md-3">

                        <label for="add-project-track-project-select">
                            To Project:
                        </label>

                    </div>

                    <div class="col-md-9">

                        <select class="custom-select" style="width: 100%;" id="add-project-track-project-select" v-model="selectedProject">
                            <option disabled value="">Please select one</option>
                            <option v-for="(project, index) in projects" v-bind:value="project">
                                {{ index+1 }}) {{ project.name }}
                            </option>
                        </select>

                    </div>

                </div>

            </div>

        </div>

        <div class="pt-4">

            <a class="btn btn-raised btn-danger btn-xl font-weight-semibold" href="#" v-on:click.prevent="save">
                Add Track to Project
            </a>

        </div>

    </div>

</template>

<script>

	import Vue from 'vue';
	import { playerService } from '../player-service';

	export default Vue.component(
	  'add-project-track',
	  {

		  data: function () {

			  return {

				  track: null,
                  projects: [],
				  selectedProject: null

			  };

		  },

		  mounted: function () {

			  // Grab the projects.
			  playerService.$on(
			    'projects-updated',
			    ( projects ) => {

				    this.projects = [];

				    for ( let projectId in projects ) {

					    if (projects.hasOwnProperty( projectId )) {

                            if(window.authenticatedUserQuicklistId && window.authenticatedUserQuicklistId != projects[projectId].id){
                                this.projects.push( projects[ projectId ] );
                            }

					    }

				    }
			    }
			  );

			  playerService.$on(
				'add-project-track',
				( track ) => {

					// Update curr track for modal + reset selected project.
					this.track = track;
					this.selectedProject = null;

					// Open the modal.
					window.webpackOpenBsModalWorkaround( '#addProjectTrackModal' );

				}
			  );

		  },

          watch: {

              track: function( value ) {

                  this.reset();

              }

          },

		  methods: {

		  	save: function() {

		  		if( !this.selectedProject ) {

		  			alert( 'To add track you must select a project.' );

		  			return false;

                }

			    playerService.addProjectTrack( this.selectedProject, this.track );

            },

              reset: function() {

                  this.selectedProject = null;

              }

		  },

	  }
	);

</script>
